import { Invoice } from "../../types/InvoiceTypes";
import { getInvoiceCurrencies } from "../../utils/invoice";

export const useInvoiceCurrencies = (invoice?: Invoice) => {
  if (!invoice) {
    return undefined;
  }

  return getInvoiceCurrencies(invoice);
};
